import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { handlePaginatedParameters } from "../_helpers/handle-parameters";
import { optionsWithDefaultsPaginated } from "../_helpers/options-with-defaults";
import type { PaginatedOptions, UseQueryOptionsNoKeyAndFn } from "../_types";
import { VEHICLE_BUY_IN_RESOURCE } from "./use-vehicle-buy-in-create-data.query";

export const VEHICLE_BUY_IN_EMPLOYEE_SEARCH_OPERATION = "employees/search" as const;
export const VEHICLE_BUY_IN_EMPLOYEE_SEARCH_API_PATH =
  `/v1/${VEHICLE_BUY_IN_RESOURCE}/${VEHICLE_BUY_IN_EMPLOYEE_SEARCH_OPERATION}` as const;

export type VehicleBuyInEmployeeSearchParameters =
  paths[typeof VEHICLE_BUY_IN_EMPLOYEE_SEARCH_API_PATH]["post"]["parameters"]["query"];
export type VehicleBuyInEmployeeSearchResponse =
  paths[typeof VEHICLE_BUY_IN_EMPLOYEE_SEARCH_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export function useVehicleBuyInEmployeeSearchQuery({
  options,
  enabled,
  queryOptions,
}: {
  options?: PaginatedOptions<VehicleBuyInEmployeeSearchParameters, never>;
  enabled?: boolean;
  queryOptions?: UseQueryOptionsNoKeyAndFn<
    VehicleBuyInEmployeeSearchResponse,
    Error,
    VehicleBuyInEmployeeSearchResponse,
    readonly unknown[]
  >;
} = {}) {
  const resolvedOptions =
    optionsWithDefaultsPaginated<PaginatedOptions<VehicleBuyInEmployeeSearchParameters, never>>(options);
  const parameters = handlePaginatedParameters(resolvedOptions.parameters);

  return useQuery({
    queryKey: [VEHICLE_BUY_IN_RESOURCE, VEHICLE_BUY_IN_EMPLOYEE_SEARCH_OPERATION, { parameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<VehicleBuyInEmployeeSearchResponse>(
        VEHICLE_BUY_IN_EMPLOYEE_SEARCH_API_PATH,
        undefined,
        { params: parameters },
      );
      return response.data;
    },
    ...queryOptions,
    enabled,
  });
}
